import { Button, Grid, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { aboutUsTimeLineObj } from 'assets/animation/portalAnimation';
import { useSelector } from 'react-redux';
import { IApplicationState } from 'store/state/app-state';

const AboutUs: React.FC = () => {
    const setting = useSelector((state: IApplicationState) => state?.Setting);

    const aboutUsTimeLine = React.useRef(null);

    React.useEffect(() => {
        aboutUsTimeLineObj(aboutUsTimeLine);
    }, []);

    const handleClinicianLoginClick = () => {
        window.open(setting?.cliniciaN_PORTAL_APPLICATION_URL, '_blank');
    };

    return (
        <section className="about-us gsap-about" ref={aboutUsTimeLine}>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <div className="about-us-mockup">
                            <div className="block-layer">
                                <div className="circle top"></div>
                                <div className="color-layer">
                                    <div className="frame-block heart">
                                        <div className="svg-wrap">
                                            <img src={images.heartIcon} alt="Heart Icon" />
                                        </div>
                                        <div>
                                            <strong>Focus On</strong>
                                            <span>serving rural</span>
                                        </div>
                                    </div>
                                    <img src={images.aboutUsMockup} alt="Image" className="main-mockup" />
                                    <div className="frame-block mental">
                                        <div className="svg-wrap">
                                            <img src={images.mentalDisordersIcon} alt="Icon" />
                                        </div>
                                        <div>
                                            <strong>Timely</strong>
                                            <span>mental health care</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="circle bottom"></div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="about-us-content">
                            <Typography variant="h3" className="section-title">
                                About Healthreach
                            </Typography>
                            <ul>
                                <li>
                                    Healthreach is an Australian tech company providing timely comprehensive mental
                                    health services through independent psychiatrists, psychologists and other
                                    clinicians.
                                </li>
                                <li>We have a particular focus towards servicing rural population</li>
                                <li>
                                    Our platform is technologically sophisticated with up-to-date integrations. It is
                                    built by Australian doctors, psychologists and clinicians with combined half century
                                    of mental health experience.
                                </li>
                                <li>
                                    We intend to provide a smooth and seamless experience for patients accessing care
                                    and for doctors/clinicians delivering care
                                </li>
                            </ul>
                            <Button
                                variant="contained"
                                size="large"
                                title="Join as Clinician"
                                onClick={handleClinicianLoginClick}
                            >
                                Join as Clinician
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(AboutUs);
